import JSONAPISerializer from '@ember-data/serializer/json-api';

/**
 * This serializer will flatten all 'attributes' and 'relationship' data before sending to the server
 *
 let json = {
      data: {
        attributes: {
          id: 23,
          title: 'hi there',
          description: 'my description'
        },
        relationships: {
          services: {

          },
          activityFeedItems: {

          },
          ...
        }
      }
    };

    BECOMES

 let json = {
      id: 23,
      title: 'hi there',
      description: 'my description',
      relationships: {
        services: {

        },
        activityFeedItems: {

        }
      }
    };
 */
export default JSONAPISerializer.extend({
  /**
   * @inheritDoc
   */
  serialize(snapshot, options) {
    let json = this._super(snapshot, options);

    Object.keys(json.data.attributes).forEach(attribute => {
      let attributeValue = json.data.attributes[attribute];
      if (attributeValue) {
        json[attribute] = attributeValue;
      }
    });
    delete json.data.attributes;

    Object.keys(json.data.relationships).forEach(relationship => {
      let relationshipJson = json.data.relationships[relationship];
      if (!relationshipJson.data) {
        return;
      }

      if (!json['relationships']) {
        json['relationships'] = {};
      }

      json['relationships'][relationship] = relationshipJson;
    });
    delete json.data.relationships;

    delete json.data;
    return json;
  }
});
